import { createContext } from 'react';

export interface RedirectContextType {
  redirectToUrlAfterLogin: boolean;
  redirectTo?: string;
  setRedirectToUrlAfterLogin: (value: boolean) => void;
  setRedirectTo: (url: string) => void;
}

export const RedirectContext = createContext<RedirectContextType | undefined>(undefined);
